var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var ensureAddress = require('orbit-db-access-controllers/src/utils/ensure-ac-address');

var EventEmitter = require('events').EventEmitter;

var entryIPFS = require('ipfs-log/src/entry');

var isIPFS = require('is-ipfs');

var orbitAddress = require('orbit-db/src/orbit-db-address');

var type = 'thread-access';
var MODERATOR = 'MODERATOR';
var MEMBER = 'MEMBER';

var isValid3ID = function isValid3ID(did) {
  var parts = did.split(':');
  if (!parts[0] === 'did' || !parts[1] === '3') return false;
  return isIPFS.cid(parts[2]);
};

var ThreadAccessController = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(ThreadAccessController, _EventEmitter);

  var _super = _createSuper(ThreadAccessController);

  function ThreadAccessController(orbitdb, ipfs, identity, firstModerator, options) {
    var _this;

    _classCallCheck(this, ThreadAccessController);

    _this = _super.call(this);
    _this._orbitdb = orbitdb;
    _this._db = null;
    _this._options = options || {};
    _this._ipfs = ipfs;
    _this._members = Boolean(options.members);
    _this._firstModerator = firstModerator;
    _this._threadName = options.threadName;
    _this._identity = identity;
    _this._encKeyId = options.encKeyId;
    return _this;
  }

  _createClass(ThreadAccessController, [{
    key: "address",
    get: // return address of AC (in this case orbitdb address of AC)
    function get() {
      return this._db.address;
    }
  }, {
    key: "canAppend",
    value: function () {
      var _canAppend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry, identityProvider) {
        var trueIfValidSig, op, mods, members, isMod, isMember, hash, delEntry;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                trueIfValidSig = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return identityProvider.verifyIdentity(entry.identity);

                          case 2:
                            return _context.abrupt("return", _context.sent);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function trueIfValidSig() {
                    return _ref.apply(this, arguments);
                  };
                }();

                op = entry.payload.op;
                mods = this.capabilities['moderators'];
                members = this.capabilities['members'];
                isMod = mods.includes(entry.identity.id);
                isMember = members.includes(entry.identity.id);

                if (!(op === 'ADD')) {
                  _context2.next = 15;
                  break;
                }

                if (this._members) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 10;
                return trueIfValidSig();

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 11:
                if (!(isMember || isMod)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 14;
                return trueIfValidSig();

              case 14:
                return _context2.abrupt("return", _context2.sent);

              case 15:
                if (!(op === 'DEL')) {
                  _context2.next = 28;
                  break;
                }

                hash = entry.payload.value;
                _context2.next = 19;
                return entryIPFS.fromMultihash(this._ipfs, hash);

              case 19:
                delEntry = _context2.sent;

                if (!(delEntry.identity.id === entry.identity.id)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 23;
                return trueIfValidSig();

              case 23:
                return _context2.abrupt("return", _context2.sent);

              case 24:
                if (!isMod) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 27;
                return trueIfValidSig();

              case 27:
                return _context2.abrupt("return", _context2.sent);

              case 28:
                return _context2.abrupt("return", false);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function canAppend(_x, _x2) {
        return _canAppend.apply(this, arguments);
      }

      return canAppend;
    }()
  }, {
    key: "capabilities",
    get: function get() {
      if (!this._capabilities) this._updateCapabilites();
      return this._capabilities;
    }
  }, {
    key: "getEncryptedKey",
    value: function getEncryptedKey(did) {
      if (!this._encKeyId) throw new Error("getEncryptedKey: only available for confidential threads");
      var didEntries = Object.entries(this._db.index).map(function (entry) {
        return {
          id: entry[1].payload.value.id,
          encryptedReadKey: entry[1].payload.value.encryptedReadKey
        };
      }).filter(function (entry) {
        return entry.id === did;
      });
      if (didEntries.length === 0) throw new Error("getEncryptedKey: no access for ".concat(did));
      return didEntries[0].encryptedReadKey;
    }
  }, {
    key: "_updateCapabilites",
    value: function _updateCapabilites() {
      var moderators = [],
          members = [];

      if (this._db) {
        moderators.push(this._db.access._firstModerator);
        Object.entries(this._db.index).forEach(function (entry) {
          var capability = entry[1].payload.value.capability;
          var id = entry[1].payload.value.id;

          if (capability === MODERATOR) {
            if (!moderators.includes(id)) moderators.push(id);
          }

          if (capability === MEMBER) members.push(id);
        });
      }

      this._capabilities = {
        moderators: moderators,
        members: members
      };
      return this._capabilities;
    }
  }, {
    key: "get",
    value: function get(capability) {
      return this.capabilities[capability] || [];
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._db.close();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(address) {
        var isAddress;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isAddress = orbitAddress.isValid(address);

                if (!this._db) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return this._db.close();

              case 4:
                _context4.next = 6;
                return this._orbitdb.feed(ensureAddress(address), this._createOrbitOpts(isAddress));

              case 6:
                this._db = _context4.sent;

                this._db.events.on('ready', this._onUpdate.bind(this));

                this._db.events.on('write', this._onUpdate.bind(this));

                this._db.events.on('replicated', this._onUpdate.bind(this));

                _context4.next = 12;
                return this._db.load();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function load(_x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "_createOrbitOpts",
    value: function _createOrbitOpts() {
      var loadByAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var accessController = {
        type: 'moderator-access',
        firstModerator: this._firstModerator,
        members: this._members,
        encKeyId: this._encKeyId
      };
      var opts = {
        identity: this._identity,
        sync: true
      };
      return Object.assign(opts, loadByAddress ? {} : {
        accessController: accessController
      });
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var address, manifest;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._orbitdb.determineAddress("".concat(this._threadName, "/_access"), 'feed', this._createOrbitOpts());

              case 2:
                address = _context5.sent;
                manifest = {
                  address: address.toString(),
                  firstModerator: this._firstModerator,
                  members: this._members
                };
                if (this._encKeyId) manifest.encKeyId = this._encKeyId;
                return _context5.abrupt("return", manifest);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "grant",
    value: function () {
      var _grant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(capability, id, encryptedReadKey) {
        var entry;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this._db.access.isValidCapability(capability)) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('grant: Invalid capability to grant');

              case 2:
                if (!(capability === MEMBER && this.capabilities['members'].includes(id))) {
                  _context6.next = 4;
                  break;
                }

                throw new Error("grant: capability ".concat(capability, " has already been granted to ").concat(id));

              case 4:
                if (!(capability === MODERATOR && this.capabilities['moderators'].includes(id) && this.capabilities['moderators'].length !== 1)) {
                  _context6.next = 6;
                  break;
                }

                throw new Error("grant: capability ".concat(capability, " has already been granted to ").concat(id));

              case 6:
                if (!(this._encKeyId && !encryptedReadKey)) {
                  _context6.next = 8;
                  break;
                }

                throw new Error('grant: confidential threads require access to be granted with encrypted key');

              case 8:
                _context6.prev = 8;
                entry = {
                  capability: capability,
                  id: id
                };
                if (encryptedReadKey) entry.encryptedReadKey = encryptedReadKey;
                _context6.next = 13;
                return this._db.add(entry);

              case 13:
                _context6.next = 20;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](8);

                if (!_context6.t0.toString().includes('not append entry')) {
                  _context6.next = 19;
                  break;
                }

                throw new Error("grant: Capability ".concat(capability, " can not be granted to ").concat(id));

              case 19:
                throw _context6.t0;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[8, 15]]);
      }));

      function grant(_x4, _x5, _x6) {
        return _grant.apply(this, arguments);
      }

      return grant;
    }()
  }, {
    key: "_onUpdate",
    value: function _onUpdate() {
      this._updateCapabilites();

      this.emit('updated');
    }
    /* Factory */

  }], [{
    key: "type",
    get: function get() {
      return type;
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orbitdb) {
        var options,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};

                if (options.firstModerator) {
                  _context7.next = 3;
                  break;
                }

                throw new Error('Thread AC: firstModerator required');

              case 3:
                if (options.address) options.threadName = options.address.split('/')[3];
                return _context7.abrupt("return", new ThreadAccessController(orbitdb, orbitdb._ipfs, options.identity, options.firstModerator, options));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function create(_x7) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ThreadAccessController;
}(EventEmitter);

module.exports = ThreadAccessController;